import classes from '../../../Schreibtisch.module.css';
import { ReactElement, useState } from 'react';
import { Accordion, Stack } from '@efast_public/fjd-component-library';
import {
  CaseDetailsModel,
  ApplicantEidPersonalData
} from '../../../../../api/models/Case/CaseDetailsModel';
import { FormatUtil } from '../../../../../shared/utils/formatUtil';
import { DescriptionList } from '@efast_public/fjd-component-library';

interface IShowAusweisdaten {
  givenNames?: string;
  givenFamilyNames?: string;
  street?: string;
  zipCity?: string;
  country?: string;
  birthDate?: string;
  nationality?: string;
  birthName?: string;
}

// Get the object like we need it in the component
function validateAndMapToAusweisdaten(
  caseDetailsModel: CaseDetailsModel
): IShowAusweisdaten | undefined {
  return mapApplicantEid(caseDetailsModel.applicantEidPersonalData);
}

function mapApplicantEid(
  applicantEid?: ApplicantEidPersonalData | null
): IShowAusweisdaten | undefined {
  if (!applicantEid) {
    return undefined;
  }

  const birthDate = applicantEid.birthDate
    ? FormatUtil.formatDateTime(new Date(applicantEid.birthDate), 'DD.MM.YYYY')
    : undefined;

  const street = [applicantEid.address?.street]
    .filter(Boolean)
    .join(' ')
    .trim();

  const zipCity = [applicantEid.address?.zipCode, applicantEid.address?.city]
    .filter(Boolean)
    .join(' ')
    .trim();

  return {
    givenNames: applicantEid.givenName,
    givenFamilyNames: applicantEid.familyName,
    street: street || undefined,
    zipCity: zipCity || undefined,
    country: applicantEid.address?.country,
    birthDate,
    nationality: applicantEid.nationality,
    birthName: applicantEid.birthName
  };
}

interface AusweisdatenProps {
  readonly caseDetailsModel: CaseDetailsModel;
}

function Ausweisdaten(props: AusweisdatenProps): ReactElement {
  const [openCard, setOpenCard] = useState(false);
  const ausweisdaten: IShowAusweisdaten | undefined =
    validateAndMapToAusweisdaten(props.caseDetailsModel);

  return (
    <Stack direction="column">
      <Accordion
        onToggle={(expanded) => setOpenCard(expanded)}
        expanded={openCard}
        label={
          <h2 style={{ marginTop: '0.17rem' }}>
            <span
              style={{ marginLeft: '0.63rem' }}
              data-testid={'expand_collapse_ausweidaten'}
            >
              Ausweisdaten
            </span>
            {!ausweisdaten && (
              <span
                style={{
                  marginLeft: '0.4rem',
                  fontWeight: 'normal'
                }}
              >
                (liegen nicht vor)
              </span>
            )}
          </h2>
        }
      >
        <div style={{ marginLeft: '10px', marginRight: '10px' }}>
          <div
            data-testid={'ausweisdaten'}
            className={classes.collapsibleCardBody}
          >
            <DescriptionList>
              <DescriptionList.Item
                key={'givenNames'}
                title={'Vorname(n)'}
                description={ausweisdaten?.givenNames || '- Keine Angabe -'}
              />
              <DescriptionList.Item
                key={'givenFamilyNames'}
                title={'Nachname(n)'}
                description={ausweisdaten?.givenFamilyNames || '- Keine Angabe -'}
              />
              <DescriptionList.Item
                key={'street'}
                title={'Straße, Haus-Nr.'}
                description={ausweisdaten?.street || '- Keine Angabe -'}
              />
              <DescriptionList.Item
                key={'zipCity'}
                title={'PLZ, Ort'}
                description={ausweisdaten?.zipCity || '- Keine Angabe -'}
              />
              <DescriptionList.Item
                key={'country'}
                title={'Staat'}
                description={ausweisdaten?.country || '- Keine Angabe -'}
              />
              <DescriptionList.Item
                key={'birthDate'}
                title={'Geburtsdatum'}
                description={ausweisdaten?.birthDate || '- Keine Angabe -'}
              />
              <DescriptionList.Item
                key={'nationality'}
                title={'Nationalität'}
                description={ausweisdaten?.nationality || '- Keine Angabe -'}
              />
              <DescriptionList.Item
                key={'birthName'}
                title={'Geburtsname'}
                description={ausweisdaten?.birthName || '- Keine Angabe -'}
              />
            </DescriptionList>
          </div>
        </div>
      </Accordion>
    </Stack>
  );
}

export default Ausweisdaten;
